import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useDeleteProject } from "../api";
import { DeleteProjectDialog } from "./DeleteProjectDialog";
import styles from "./DeleteProjectSection.module.css";

export const DeleteProjectSection = ({
  projectId,
  projectName,
}: {
  projectId: string;
  projectName: string;
}) => {
  const deleteProject = useDeleteProject();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [confirming, setConfirming] = useState(false);

  const onDelete = async () => {
    setError(null);
    try {
      await deleteProject.mutateAsync(projectId);
      navigate("/projects");
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    }
  };

  return (
    <div className={styles.row}>
      <p className={styles.help}>
        Deletes the project, all of its agent runs and conversations, and every attached file. It
        cannot be undone.
      </p>
      <button
        type="button"
        className={styles.deleteBtn}
        onClick={() => {
          setError(null);
          setConfirming(true);
        }}
        disabled={!projectId || deleteProject.isLoading}
      >
        Delete project
      </button>
      <DeleteProjectDialog
        open={confirming}
        projectName={projectName}
        deleting={deleteProject.isLoading}
        error={error}
        onCancel={() => setConfirming(false)}
        onConfirm={() => void onDelete()}
      />
    </div>
  );
};
